import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateParticipantFileLabel } from '../mutations/createParticipantFileLabel.mutation';
import type {
  CreateParticipantFileLabelMutation,
  CreateParticipantFileLabelMutationVariables,
} from '../types';

export const useCreateParticipantFileLabelMutation = (
  options?: MutationOptions<
    CreateParticipantFileLabelMutation,
    CreateParticipantFileLabelMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantFileLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
